import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import shortid from 'shortid';
import { replace } from 'lodash';
import { withRouter, Switch, Route } from 'react-router-dom';
import IndexPage from './AutomationEmailIndexPage';
import DetailPage from './AutomationEmailDetailPage';
// import FeedbackRequestAutomationDetailPage from './FeedbackRequestAutomationDetailPage';
import Pusher from '../../../../components/pusher';

class AutomationEmailPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sessionId: shortid.generate(), // if user open another window, this suppose to be uniq
    };
    this.handleAutomationUpdate = this.handleAutomationUpdate.bind(this);
  }

  handleAutomationUpdate(evt) {
    const { location: { pathname }, type } = this.props;
    const base = `/setup/feedback-requests/${type}-emails`; // use match!
    const { id, sessionId, name, user } = evt;
    const isSessionMatch = sessionId === this.state.sessionId;

    // /setup/feedback-requests/{type}-emails

    // /setup/feedback-requests/{type}-emails/accounts/id
    // /setup/feedback-requests/{type}-emails/opportunities/id

    // extract the id from the pathname
   
    if (!isSessionMatch) {
      // different session (tab/window)
      let currentId = replace(pathname, `${base}/accounts/`, '');
      currentId = replace(currentId, `${base}/opportunities/`, '');
      const isRoot = pathname === base;
      const isDetail = currentId && currentId !== base;
      const isIdMatch = isDetail && currentId === id;
      if (isIdMatch) {
        // viewing detail, id match
        const el = (<div>Automation Email <strong>{name}</strong> has been updated by {user}! Please reload this page.</div>);
        this.context.addNotification(el, 
          { 
            type: 'warning', 
            autoClose: false,
            closeOnClick: false,
            onClose: () => {
              window.location.reload();
            },
          },
        );
      } else if (isRoot && type === evt.type) {
        // is root
        const el = (<div>Automation Email <strong>{name}</strong> has been updated by {user}! This page will be reloaded.</div>);
        this.context.addNotification(el, 
          { 
            type: 'warning', 
            autoClose: 3 * 1000,
            closeOnClick: false,
            onClose: () => {
              window.location.reload();
            },
          },
        );
      }
      // otherwise: view detail of other automation, ignore
    }
  }


  renderSubtitle() {
    const { type } = this.props;

    let title = null;
    if (type === 'summary') {
      title = 'Configure feedback request summary email settings. Summary emails are sent when contacts are submitted for an opportunity.';
    } else if (type === 'reminder') {
      title = 'Configure feedback request reminder email settings. Reminder emails are sent daily.';
    } else if (type === 'alert') {
      title = 'Configure termination alert email settings. Alert emails are sent when a user terminates outreach for a contact in TruVoice Automation.';
    } else if (type === 'exclusion') {
      title = 'Configure opportunity exclusion alert email settings. Exclusion alert emails are sent when a user excludes an opportunity for feedback request on TruVoice Automation.';
    }
    if (!title) {
      return null;
    }
    return (
      <div className="well">{title}</div>
    );
  }

  render() {
    const { validCollectors, type, emergencySettings } = this.props;
    const { sessionId } = this.state;
    return (
      <div>
        {this.renderSubtitle()}
        <Switch>
          <Route
            exact
            path={`/setup/feedback-requests/${type}-emails`}
            render={(props) => {
              return (<IndexPage emergencySettings={emergencySettings} validCollectors={validCollectors} type={type} {...props} />);
            }}
          />
          <Route
            path={`/setup/feedback-requests/${type}-emails/:source(opportunities|accounts)/:id`}
            render={(props) => {
              return (<DetailPage emergencySettings={emergencySettings} validCollectors={validCollectors} type={type} {...props} sessionId={sessionId} />);
            }}
          />
        </Switch>
        <Pusher event="automationUpdated" handler={this.handleAutomationUpdate} />
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(/* state */) {
  return {
  };
}

AutomationEmailPage.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  type: PropTypes.string.isRequired,
  validCollectors: PropTypes.arrayOf(PropTypes.shape({})),
  emergencySettings: PropTypes.shape({
    disabled: PropTypes.bool,
  }),
};
AutomationEmailPage.defaultProps = {
  validCollectors: [],
  emergencySettings: null,
};
AutomationEmailPage.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};

export default withRouter(connect(mapStateToProps)(AutomationEmailPage));
